import React, { ReactElement } from 'react'
import { formatPriceString } from '../../common/helpers/number-formatters'

type DeliveryPriceDescriptionProps = {
  shippingAmount: string;
  shippingQuoteNeeded: boolean;
}

const DeliveryPriceDescription = ({
  shippingAmount, shippingQuoteNeeded
}: DeliveryPriceDescriptionProps): ReactElement => {
  const description = (): string => {
    if (shippingQuoteNeeded) {
      return '£call'
    }
    if (shippingAmount === '0.0') {
      return 'Free'
    }
    return formatPriceString(shippingAmount)
  }

  return <>{description()}</>
}

export default DeliveryPriceDescription
